import React, { ReactNode, Ref } from "react"
import { TooltipIcon } from "../TooltipIcon"
import { ErrorMessage } from "@hookform/error-message"
import { RegisterOptions, UseFormRegister } from "react-hook-form"
import { Container, Description, ErrorMessageInfo, Field, Label, Error } from "./Input.styled"

type TypeInput = {
  placeholder?: string
  label?: string | ReactNode
  name: string
  type?: string
  // eslint-disable-next-line
  errors?: any
  // eslint-disable-next-line
  onChange?: any
  ref?: Ref<HTMLInputElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string | number
  errorType?: string
  description?: string
  removePaddingBottom?: boolean
  // eslint-disable-next-line
  value?: any
  toolTip?: string
  hooksErrorMessage?: boolean
  accept?: string
  min?: string | number
  max?: string | number
  // eslint-disable-next-line
  register?: UseFormRegister<any>
  // eslint-disable-next-line
  validation?: RegisterOptions<any, string> | undefined
}

const Input: React.FC<TypeInput> = React.forwardRef<
  HTMLInputElement,
  React.PropsWithChildren<TypeInput>
>(
  (
    {
      type,
      name,
      placeholder,
      description,
      label,
      errors,
      onChange,
      defaultValue,
      disabled,
      removePaddingBottom = false,
      value,
      toolTip,
      hooksErrorMessage,
      min,
      register,
      validation,
      ...props
    },
    ref
  ) => {
    const error = errors?.[name]

    const isDisabled = () => {
      if (disabled) return disabled
      return false
    }

    return (
      <Container $removePaddingBottom={removePaddingBottom}>
        {label && (
          <Label>
            {label}
            {toolTip && <TooltipIcon content={toolTip} />}
            <ErrorMessageInfo $show={error}>- {error?.message}</ErrorMessageInfo>
          </Label>
        )}

        {register ? (
          <Field
            {...register(name, validation ?? validation)}
            disabled={isDisabled()}
            defaultValue={defaultValue}
            placeholder={placeholder}
          />
        ) : (
          <Field
            ref={ref}
            type={type || "text"}
            placeholder={placeholder}
            $invalid={error}
            defaultValue={defaultValue}
            onChange={(e) => onChange(e)}
            disabled={isDisabled()}
            onWheelCapture={(e) => e.currentTarget.blur()}
            value={value}
            min={min}
            {...props}
          />
        )}
        {description && <Description>{description}</Description>}
        {name && hooksErrorMessage && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <Error>{message}</Error>}
          />
        )}
      </Container>
    )
  }
)

Input.displayName = "Input"

export default Input
